import React from "react";
import styled from "styled-components";
import { Item } from "../../models/item";
import { Readmore } from "./Readmore";
import { useBreakpoint } from "../../utilities/media-js-breakpoints";

const ReadmoreCard = styled.div<ReadMoreProps>`
    position: absolute;
    width: ${props => props.width};
    top: ${props => props.top};
    right: ${props => props.right};
    background: #fff;
    border-radius: 4px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.13);
    z-index: 100;
    box-sizing: border-box;

    animation: inTransition 0.4s cubic-bezier(0, 0, 0.4, 1.09);

    @keyframes inTransition {
        0% {
            opacity: 0;
            transform: translateY(40px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

interface ReadMoreProps {
    top: string;
    width: string;
    right: string;
}

export const DesktopReadmoreCard = ({ item }: { item: Item }) => {
    const breakpoints = useBreakpoint();

    let topPos = "15px";
    let widhtSize = "250px";
    let rightPos = "10px";

    if (breakpoints.md) {
        topPos = "50px";
        widhtSize = "300px";
        rightPos = "25px";
    }
    // TODO: We should add another check if the window height is below 600px.
    if (window.innerHeight < 610) {
        const mHeight = 10;
        topPos = `${mHeight}px`;
    }

    return (
        <ReadmoreCard top={topPos} width={widhtSize} right={rightPos}>
            <Readmore item={item} />
        </ReadmoreCard>
    );
};
